import React from 'react';
// import {withSnackbar} from "notistack";
import {Link} from 'react-router-dom';
import {Modal} from "react-bootstrap";
import "./Modal.css"
import Utils from '../../../utils/utils';

function formatMoney(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
function onlyNumber(value) {
    return  Utils.filterNumberOnly(value);
}

class modalCreateBill extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showCreate: true,
            type: '',
            start: '',

            end: '',
            price: '',
            commercePrice: '',
            manufacturingPrice: '',
            buildingPrice: '',
        };
    }

    onSubmit = () => {
        let {start, end, commercePrice, manufacturingPrice, buildingPrice} = this.state;
        let list =  [
            {
            business: "COMMERCE_SERVICE",
            price: commercePrice,
            requirementConstraint: `${start} -  ${end}`,
            status: "DISABLED",
            type: "INVOICE"
            },
            {
            business: "MANUFACTURING_MACHINING",
            price: manufacturingPrice,
            requirementConstraint: `${start} -  ${end}`,
            status: "DISABLED",
            type: "INVOICE"
            },
            {
            business: "BUILDING_INSTALLATION",
            price: buildingPrice,
            requirementConstraint: `${start} -  ${end}`,
            status: "DISABLED",
            type: "INVOICE"
            },
        ]

        let item = {
            business: "COMMERCE_SERVICE",
            commercePrice: commercePrice,
            manufacturingPrice: manufacturingPrice,
            buildingPrice: buildingPrice,
            requirementConstraint: `${start} -  ${end}`,
            type: "INVOICE"
        };
        this.props.create(list, item)
        this.setState({start: '', end: '', commercePrice: '', manufacturingPrice: '', buildingPrice: ''})
    }

    render() {
        const modalProp = {
            show: this.props.show,
            // onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>THÊM MỚI HÓA ĐƠN</b>
                            </h1>
                        </div>
                        <div className='mt-3 mb-3'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2 pl-0">
                                    <label className="col-5 label-item pl-0">Số lượng hóa đơn</label>
                                    <input
                                        maxLength={3} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.start}
                                        onChange={(event) => {
                                            this.setState({
                                                start: onlyNumber(event.target.value)
                                            })
                                        }}
                                    />
                                    <label className="col-1 label-item pl-1">đến</label>
                                    <input
                                        maxLength={3} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.end}
                                        onChange={(event) => {
                                            this.setState({
                                                end: onlyNumber(event.target.value)
                                            })
                                        }}
                                    />
                                </div>
                                <label className="col-5 label-item pl-0">Giá gói cước (VNĐ)</label>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-5 label-item pl-0">Thương mại</label>
                                    <input
                                        type="text"
                                        maxLength={10}
                                        className="form-control shadow-none"
                                        value={formatMoney(this.state.commercePrice)}
                                        onChange={(event) => {
                                                this.setState({
                                                    commercePrice: onlyNumber(event.target.value.trim())
                                                })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-5 label-item pl-0">Sản xuất</label>
                                    <input
                                        type="text"
                                        maxLength={10}
                                        className="form-control shadow-none"
                                        value={formatMoney(this.state.manufacturingPrice)}
                                        onChange={(event) => {
                                                this.setState({
                                                    manufacturingPrice: onlyNumber(event.target.value.trim())
                                                })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-5 label-item pl-0">Xây dựng</label>
                                    <input
                                        type="text"
                                        maxLength={10}
                                        className="form-control shadow-none"
                                        value={formatMoney(this.state.buildingPrice)}
                                        onChange={(event) => {
                                                this.setState({
                                                    buildingPrice: onlyNumber(event.target.value.trim())
                                                })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className=" align-right col-12">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                    disabled={this.state.start.length === 0 || this.state.end.length === 0 || this.state.price.commercePrice === 0 || this.state.price.manufacturingPrice === 0 || this.state.price.buildingPrice === 0}
                                    onClick={() => this.onSubmit()}
                                >
                                    Đồng ý
                                </button>
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s w-50 type-button-fix btn btn-light shadow-none"
                                    onClick={this.props.onHide}
                                >
                                    Hủy bỏ
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default modalCreateBill
